import { SvgIcon, type SvgIconProps } from './SvgIcon';

export const RevertIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox={'0 0 24 24'} {...props}>
    <path
      d={
        'M9.66797 4L10.7646 5.09668L8.01953 7.84766L13.9756 7.84766C17.1324 7.84766 19.6914 ' +
        '10.4067 19.6914 13.5635C19.6914 16.7203 17.1324 19.2793 13.9756 19.2793L7.44336 ' +
        '19.2793L7.44336 17.6465L13.9756 17.6465C16.2304 17.6465 18.0586 15.8183 18.0586 ' +
        '13.5635C18.0586 11.3086 16.2304 9.48047 13.9756 9.48047L8.01172 9.48047L10.7646 ' +
        '12.2393L9.66797 13.3359L5 8.66797L9.66797 4Z'
      }
      fill={'currentColor'}
    />
  </SvgIcon>
);
